module.exports = __webpack_public_path__ + "img/ic_footer_social_facebook.8b6a902b.svg";